import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white p-6"
}
const _hoisted_2 = { class: "font-bold text-medium mb-4" }
const _hoisted_3 = { class: "bg-chart py-4 px-6 rounded mt-3 mt-0" }
const _hoisted_4 = { class: "font-bold text-light mb-7" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("canvas", { id: "reportsParcelsCanvas" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.state.isEmpty)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("report.parcels.title")), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("report.parcels.chart.title")), 1),
          _hoisted_5
        ])
      ]))
    : _createCommentVNode("", true)
}